import type { ToastObject } from '@base-ui/react'

import { ActionWrapper } from './ActionWrapper'
import { ButtonClose } from './ButtonClose'
import { Container } from './Container'
import { Content } from './Content'
import { Description } from './Description'
import { IconAlert } from './IconAlert'
import { SnackbarType } from './SnackbarType'
import { Text } from './Text'
import { Title } from './Title'

type Props = {
	toast: ToastObject<object>
}

export const Snackbar = ({ toast }: Props) => (
	<Container toast={toast}>
		<Content>
			{toast.type === SnackbarType.Error && <IconAlert size={22} />}
			<Text>
				<Title />
				<Description />
			</Text>
			<ActionWrapper>
				<ButtonClose />
			</ActionWrapper>
		</Content>
	</Container>
)
